export default __webpack_public_path__ + "static/media/section5.0c8b72e8.png";